import { styled } from '@styles/stitches';

const SVG = styled('svg', {
  filter:
    'drop-shadow(0 0 0.75px rgba(0,0,0,.42)) drop-shadow(0 1px 0.5px rgba(0,0,0,.018)) drop-shadow(0 2px 3px rgba(0,0,0,.2))',
});

const mainOpacity = 0.7;
const secondaryOpacity = 0.05;

export const LabelGIF = () => {
  return (
    <SVG height="20" viewBox="0 0 38 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H34C36.2091 20 38 18.2091 38 16V4C38 1.79086 36.2091 0 34 0H4ZM13.8613 10.8418V9.39453H17.5996V12.8164C17.2363 13.168 16.709 13.4785 16.0176 13.748C15.3301 14.0137 14.6328 14.1465 13.9258 14.1465C13.0273 14.1465 12.2441 13.959 11.5762 13.584C10.9082 13.2051 10.4062 12.666 10.0703 11.9668C9.73438 11.2637 9.56641 10.5 9.56641 9.67578C9.56641 8.78125 9.75391 7.98633 10.1289 7.29102C10.5039 6.5957 11.0527 6.0625 11.7754 5.69141C12.3262 5.40625 13.0117 5.26367 13.832 5.26367C14.8984 5.26367 15.7305 5.48828 16.3281 5.9375C16.9297 6.38281 17.3164 7 17.4883 7.78906L15.7656 8.11133C15.6445 7.68945 15.416 7.35742 15.0801 7.11523C14.748 6.86914 14.332 6.74609 13.832 6.74609C13.0742 6.74609 12.4707 6.98633 12.0215 7.4668C11.5762 7.94727 11.3535 8.66016 11.3535 9.60547C11.3535 10.625 11.5801 11.3906 12.0332 11.9023C12.4863 12.4102 13.0801 12.6641 13.8145 12.6641C14.1777 12.6641 14.541 12.5938 14.9043 12.4531C15.2715 12.3086 15.5859 12.1348 15.8477 11.9316V10.8418H13.8613ZM19.1523 14V5.41016H20.8867V14H19.1523ZM22.5566 5.41016V14H24.291V10.3496H27.877V8.89648H24.291V6.86328H28.4453V5.41016H22.5566Z"
        fill="white"
        fillOpacity={mainOpacity}
      />
      <path
        d="M13.8613 10.8418V9.39453H17.5996V12.8164C17.2363 13.168 16.709 13.4785 16.0176 13.748C15.3301 14.0137 14.6328 14.1465 13.9258 14.1465C13.0273 14.1465 12.2441 13.959 11.5762 13.584C10.9082 13.2051 10.4062 12.666 10.0703 11.9668C9.73438 11.2637 9.56641 10.5 9.56641 9.67578C9.56641 8.78125 9.75391 7.98633 10.1289 7.29102C10.5039 6.5957 11.0527 6.0625 11.7754 5.69141C12.3262 5.40625 13.0117 5.26367 13.832 5.26367C14.8984 5.26367 15.7305 5.48828 16.3281 5.9375C16.9297 6.38281 17.3164 7 17.4883 7.78906L15.7656 8.11133C15.6445 7.68945 15.416 7.35742 15.0801 7.11523C14.748 6.86914 14.332 6.74609 13.832 6.74609C13.0742 6.74609 12.4707 6.98633 12.0215 7.4668C11.5762 7.94727 11.3535 8.66016 11.3535 9.60547C11.3535 10.625 11.5801 11.3906 12.0332 11.9023C12.4863 12.4102 13.0801 12.6641 13.8145 12.6641C14.1777 12.6641 14.541 12.5938 14.9043 12.4531C15.2715 12.3086 15.5859 12.1348 15.8477 11.9316V10.8418H13.8613Z"
        fill="white"
        fillOpacity={secondaryOpacity}
      />
      <path d="M19.1523 14V5.41016H20.8867V14H19.1523Z" fill="white" fillOpacity={secondaryOpacity} />
      <path
        d="M22.5566 14V5.41016H28.4453V6.86328H24.291V8.89648H27.877V10.3496H24.291V14H22.5566Z"
        fill="white"
        fillOpacity={secondaryOpacity}
      />
    </SVG>
  );
};

export const LabelWEB = () => {
  return (
    <SVG height="20" viewBox="0 0 38 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H34C36.2091 20 38 18.2091 38 16V4C38 1.79086 36.2091 0 34 0H4ZM7.05078 14.5898L5 6H6.77539L8.07031 11.9004L9.64062 6H11.7031L13.209 12L14.5273 6H16.2734L14.1875 14.5898H12.3477L10.6367 8.16797L8.93164 14.5898H7.05078ZM17.1641 14.5898V6H23.5332V7.45312H18.8984V9.35742H23.2109V10.8047H18.8984V13.1426H23.6973V14.5898H17.1641ZM28.6074 6H25.1738V14.5898H28.0977C29.2031 14.582 29.9004 14.5625 30.1895 14.5312C30.6504 14.4805 31.0371 14.3457 31.3496 14.127C31.666 13.9043 31.9141 13.6094 32.0938 13.2422C32.2773 12.8711 32.3691 12.4902 32.3691 12.0996C32.3691 11.6035 32.2285 11.1719 31.9473 10.8047C31.666 10.4375 31.2637 10.1777 30.7402 10.0254C31.1113 9.85742 31.4043 9.60547 31.6191 9.26953C31.8379 8.93359 31.9473 8.56445 31.9473 8.16211C31.9473 7.79102 31.8594 7.45703 31.6836 7.16016C31.5078 6.85938 31.2871 6.61914 31.0215 6.43945C30.7598 6.25977 30.4609 6.14258 30.125 6.08789C29.793 6.0293 29.2871 6 28.6074 6ZM26.9082 9.41602V7.42969H27.9043C28.7207 7.42969 29.2148 7.43945 29.3867 7.45898C29.6758 7.49414 29.8926 7.5957 30.0371 7.76367C30.1855 7.92773 30.2598 8.14258 30.2598 8.4082C30.2598 8.68555 30.1738 8.91016 30.002 9.08203C29.834 9.25 29.6016 9.35156 29.3047 9.38672C29.1406 9.40625 28.7207 9.41602 28.0449 9.41602H26.9082ZM26.9082 13.1426V10.8457H28.3086C29.0977 10.8457 29.6094 10.8867 29.8438 10.9688C30.082 11.0508 30.2637 11.1816 30.3887 11.3613C30.5137 11.541 30.5762 11.7598 30.5762 12.0176C30.5762 12.3223 30.4941 12.5664 30.3301 12.75C30.1699 12.9297 29.9609 13.043 29.7031 13.0898C29.5352 13.125 29.1387 13.1426 28.5137 13.1426H26.9082Z"
        fill="white"
        fillOpacity={mainOpacity}
      />
      <path
        d="M7.05078 14.5898L5 6H6.77539L8.07031 11.9004L9.64062 6H11.7031L13.209 12L14.5273 6H16.2734L14.1875 14.5898H12.3477L10.6367 8.16797L8.93164 14.5898H7.05078Z"
        fill="white"
        fillOpacity={secondaryOpacity}
      />
      <path
        d="M17.1641 14.5898V6H23.5332V7.45312H18.8984V9.35742H23.2109V10.8047H18.8984V13.1426H23.6973V14.5898H17.1641Z"
        fill="white"
        fillOpacity={secondaryOpacity}
      />
      <path
        d="M25.1738 6H28.6074C29.2871 6 29.793 6.0293 30.125 6.08789C30.4609 6.14258 30.7598 6.25977 31.0215 6.43945C31.2871 6.61914 31.5078 6.85938 31.6836 7.16016C31.8594 7.45703 31.9473 7.79102 31.9473 8.16211C31.9473 8.56445 31.8379 8.93359 31.6191 9.26953C31.4043 9.60547 31.1113 9.85742 30.7402 10.0254C31.2637 10.1777 31.666 10.4375 31.9473 10.8047C32.2285 11.1719 32.3691 11.6035 32.3691 12.0996C32.3691 12.4902 32.2773 12.8711 32.0938 13.2422C31.9141 13.6094 31.666 13.9043 31.3496 14.127C31.0371 14.3457 30.6504 14.4805 30.1895 14.5312C29.9004 14.5625 29.2031 14.582 28.0977 14.5898H25.1738V6ZM26.9082 7.42969V9.41602H28.0449C28.7207 9.41602 29.1406 9.40625 29.3047 9.38672C29.6016 9.35156 29.834 9.25 30.002 9.08203C30.1738 8.91016 30.2598 8.68555 30.2598 8.4082C30.2598 8.14258 30.1855 7.92773 30.0371 7.76367C29.8926 7.5957 29.6758 7.49414 29.3867 7.45898C29.2148 7.43945 28.7207 7.42969 27.9043 7.42969H26.9082ZM26.9082 10.8457V13.1426H28.5137C29.1387 13.1426 29.5352 13.125 29.7031 13.0898C29.9609 13.043 30.1699 12.9297 30.3301 12.75C30.4941 12.5664 30.5762 12.3223 30.5762 12.0176C30.5762 11.7598 30.5137 11.541 30.3887 11.3613C30.2637 11.1816 30.082 11.0508 29.8438 10.9688C29.6094 10.8867 29.0977 10.8457 28.3086 10.8457H26.9082Z"
        fill="white"
        fillOpacity={secondaryOpacity}
      />
    </SVG>
  );
};

export const LabelVIDEO = () => {
  return (
    <SVG height="20" viewBox="0 0 48 48">
      <path
        d="M9.6 46.5c-1 0-2-.3-2.9-.8-1.8-1.1-2.9-2.9-2.9-5.1V7.3c0-2.1 1.1-4 2.9-5.1 1.9-1.1 4.1-1.1 5.9 0l30.1 17.6c1.5.9 2.3 2.4 2.3 4.1 0 1.7-.9 3.2-2.3 4.1L12.6 45.7c-.9.5-2 .8-3 .8z"
        fill="white"
        fillOpacity={mainOpacity}
      />
    </SVG>
  );
};

export const LabelAUDIO = () => {
  return (
    <SVG height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h48v48h-48z" fill="none" />
      <path
        d="M14 36h4v-24h-4v24zm8 8h4v-40h-4v40zm-16-16h4v-8h-4v8zm24 8h4v-24h-4v24zm8-16v8h4v-8h-4z"
        fill="white"
        fillOpacity={mainOpacity}
      />
    </SVG>
  );
};

export const Label3D = () => {
  return (
    <SVG height="20" viewBox="0 0 26 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 28L1 21.2V7.7L13 1L25 7.7V21.2L13 28ZM13 28V15M1 8.2L13 15M13 15L25 8.2"
        stroke="white"
        strokeOpacity={mainOpacity}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};

export const LabelPDF = () => {
  return (
    <SVG viewBox="0 0 24 24" height="20">
      <polygon points="12,3 1,9 12,15 23,9 " fill="#ffffff" opacity={mainOpacity} />
      <polygon points="19,12.8 12,17 5,12.8 5,17.2 12,21 19,17.2 " fill="#ffffff" opacity={mainOpacity} />
    </SVG>
  );
};
